import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducers } from './+state';
import { AuthGroupEffects } from './+state/auth-group.effects';

@NgModule({
  imports: [
    StoreModule.forFeature('authGroups', reducers),
    EffectsModule.forFeature([AuthGroupEffects]),
  ],
})
export class AuthGroupModule {}
